import React from 'react';
import Modal from '@lib/components/common/Modal';
import Button from '../../common/Button';
import store from '@lib/store/configuration';
import saveBlobAsFile from '../../utils/saveBlobAsFile';

export default class EditPageDocsGenerateModal extends React.Component {

    state = {
        isSubmitting: false,
        isLoading: true,
        model: {},
    }

    constructor(props) {
        super(props)

        scheduleAtDocumentReady(() => {
            this.configurationAPIService = this.props.api;
        });
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.isOpen !== this.props.isOpen) {
            this.fetchModalData()
        }
    }

    getDocumentationModalContentData() {
        return {
            type: this.getDocumentType(),
            model: store.getTransformedFormModel()
        }
    }

    fetchModalData = () => {
        var data = this.getDocumentationModalContentData();
        this.setState({
            isLoading: true
        }, () => {
            this.configurationAPIService.getDocumentationModalContent(data).then(response => {
                this.thenFetchModalData(response);
            });
        });
    }

    thenFetchModalData(response) {
        this.setState({
            model: response.data,
            languageId: response.data.language.value,
            isLoading: false
        });
    }

    executeAction = data => this.configurationAPIService.generateDocumentation(data)

    onSubmit = () => {
        this.setState({isSubmitting: true})
        let editModel = store.getTransformedFormModel();

        this.executeAction(this.buildPostModel(editModel)).then(response => {
            saveBlobAsFile(response)

            this.props.onClose()
            this.setState({isSubmitting: false})
        }).catch(() => {
            this.setState({isSubmitting: false})
        })
    }

    getWidth() {
        return null
    }

    render() {
        return (
            <Modal width={this.getWidth()} isOpen={this.props.isOpen} onClose={this.props.onClose}>
                <Modal.Header>{__(this.getDocumentType() + ' documentation')}</Modal.Header>
                <Modal.Body>
                    {this.state.isLoading ? (
                        <React.Fragment>
                            {__('Loading...')}
                        </React.Fragment>
                    ) : (
                        <React.Fragment>
                            {this.state.isSubmitting && (
                                <div className="loading-overlay" style={{backgroundColor: '#ffffff'}}>
                                    <div className="ball-loader visible">
                                        <div className="ball-loader-ball1"></div>
                                        <div className="ball-loader-ball2"></div>
                                        <div className="ball-loader-ball3"></div>
                                    </div>
                                </div>
                            )}

                            {this.renderBody()}
                        </React.Fragment>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={this.props.onClose} theme={Button.Theme.BorderOnly}>
                        {__('Cancel')}
                    </Button>

                    <Button onClick={this.onSubmit} disabled={this.state.isSubmitting} theme={Button.Theme.BorderOnly}>
                        {__(this.state.isSubmitting ? 'Generating...' : 'Generate')}
                    </Button>
                </Modal.Footer>
            </Modal>
        )
    }

    renderBody() {
        throw new Error('renderBody() not implemeted.')
    }
}